import { render } from "./balkenMitBildPaletten.vue?vue&type=template&id=0a59aba0"
import script from "./balkenMitBildPaletten.vue?vue&type=script&lang=js"
export * from "./balkenMitBildPaletten.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__